import { FeeTypeType } from '../../types/index';
import { getFeeType } from "actions/Utilities/Policy";
import { useQuery } from "react-query";

export default function useFeeType() {
  //Fetching FeeType Details
  const {data, isFetching} = useQuery("GetFeeTypes", getFeeType, {
    refetchOnWindowFocus: false,
  });
  if(data){
    data.sort((a, b) => {
        let fa = a.feeTypeName.toLowerCase(), fb = b.feeTypeName.toLowerCase();

        if (fa < fb) {
            return -1;
        }
        else if (fa > fb) {
            return 1;
        }
        else return 0;
    });
  }
  return {data: data as FeeTypeType[], isFetching};
}